export default {"src":"/_next/static/media/moonbeam.63f34507.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};